module.exports = __webpack_public_path__ + "static/img/award3_a.5b4ec71.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award3_a.png
// module id = fvEI
// module chunks = 7